import { getAppConfig } from "services/configService";
import { GET } from "services/httpService";
import urlJoin from "url-join";

const apiUrl = () => {
  return getAppConfig().MapPdfApiUrl;
};

export const getMapPdfs = async requestInfo => {
  return await GET(requestInfo, urlJoin(apiUrl(), "/v1/Pdfs/me"));
};
